export const LOCALE_CONFIG = {
  EN: {
    code: 'EN',
    label: 'English',
    intlLocale: 'en',
    htmlLang: 'en',
    direction: 'ltr',
    googleTarget: 'en',
  },
  ES: {
    code: 'ES',
    label: 'Español',
    intlLocale: 'es',
    htmlLang: 'es',
    direction: 'ltr',
    googleTarget: 'es',
  },
  VI: {
    code: 'VI',
    label: 'Tiếng Việt',
    intlLocale: 'vi',
    htmlLang: 'vi',
    direction: 'ltr',
    googleTarget: 'vi',
  },
  FIL: {
    code: 'FIL',
    label: 'Filipino',
    intlLocale: 'fil',
    htmlLang: 'fil',
    direction: 'ltr',
    googleTarget: 'fil',
  },
  'ZH-HANS': {
    code: 'ZH-HANS',
    label: '简体中文',
    intlLocale: 'zh-Hans',
    htmlLang: 'zh-Hans',
    direction: 'ltr',
    googleTarget: 'zh-CN',
  },
  AR: {
    code: 'AR',
    label: 'العربية',
    intlLocale: 'ar',
    htmlLang: 'ar',
    direction: 'rtl',
    googleTarget: 'ar',
  },
};

export const LANGUAGE_OPTIONS = Object.values(LOCALE_CONFIG).map(
  ({ code, label }) => ({
    code,
    label,
  })
);

export const DEFAULT_LANGUAGE = 'EN';
